/*
 *
 *  UI Store
 */

// Studios
const studios = {
  key: 'studios',
  name: 'الاستوديوهات',
  fullName: 'استوديوهات سينسز',
  altName: 'Studios',
  description: 'استديوهات سينسز تقع في مساحة 1300م²، تتوفر فيها الإضاءات وتقنيات التصوير وغرفة الملابس والمكياج والكنترول ومنطقة الاستراحة.',
  path: {
    name: 'ServicesBase',
    params: {
      serviceName: 'studios'
    }
  },
  nav: {
    order: 40,
    subheader: 'الخدمات',
    views: ['global']
  },
  icon: 'mdi-chair-rolling',
  featuredImg: 'gallery-55',
  components: {
    ShowcaseIntro: {
      maskImg: 'gallery-56',
      text: '<p>نمتلك استديوهات فائقة الجودة، تقع في مساحة 1300 متر مربع، تتوفر فيها الإضاءات وكافة تقنيات التصوير، إضافة إلى غرفة الملابس وغرفة المكياج وغرفة الكنترول ومنطقة الاستراحة وغرفة الاجتماعات والمكاتب.</p><p>اختيارك لاستديوهات سينسز يعكس اهتمامك بالاحترافية والجودة التي تسهم في نجاحاتك.</p>'
    },
    ShowcaseGallery: {
      body: '<h1 class="display-2 primary--text mb-6">اصنع الاستوديو</h1><p class="body-1 secondary--text text--lighten-1">الخاص بمشروعك على مساحة 1300 متر مربع.</p>',
      galleryItems: [{
          name: 'gallery-59',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-49',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-48',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-51',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-60',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-53',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-54',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-55',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-56',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-11',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-8',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-3',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-14',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-16',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-15',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-35',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-36',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-37',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-39',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-41',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-44',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-45',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-58',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        },
        {
          name: 'gallery-5',
          type: 'image',
          width: 1400,
          height: 1050,
          aspect: 70 / 53
        }
      ]
    },
    ShowcaseTypo: {
      bgs: ['gallery-14', 'gallery-11', 'gallery-15', 'gallery-3'],
      title: '<h1 class="display-2 primary--text mb-6">اختيارك لاستديوهات سينسز</h1><p class="body-1 secondary--text text--lighten-1">يعكس اهتمامك بالاحترافية والجودة التي تسهم في نجاحاتك.</p>'
    }
  }
}

// Production
const production = {
  key: 'production',
  name: 'الإنتاج',
  fullName: 'إنتاج سينسز',
  altName: 'Production',
  description: 'اعتمدنا على فريق عمل مبتكر ومعدات حديثة ونموذج عمل مثالي يبدأ بالفكرة والكتابة الإبداعية مروراً بالعمليات الفنية والإخراج المتقن.',
  path: {
    name: 'ServicesBase',
    params: {
      serviceName: 'production'
    }
  },
  nav: {
    order: 41,
    views: ['global']
  },
  icon: 'mdi-camera-iris',
  featuredImg: 'gallery-33',
  components: {
    ShowcaseIntro: {
      maskImg: 'gallery-19',
      text: '<p>ترتكز صناعتنا الإنتاجية على الإبداع والقوة لتؤثر المواد المختلفة في الجمهور كما يرغب شركاء سينسز.</p><p>لهذا اعتمدنا على فريق عمل مبتكر، ومعدات حديثة، ونموذج عمل مثالي يبدأ بالفكرة والكتابة الإبداعية، مرورًا بالعمليات الفنية والإخراج المتقن بصورته النهائية، مما يعزز ثقة عملائنا وشركائنا بحرفيتنا الفائقة.</p>'
    },
    ShowcaseGallery: {
      body: '<h1 class="display-2 primary--text mb-6">بحرفيتنا الفائقة،</h1><p class="body-1 secondary--text text--lighten-1">نعزز ثقة عملائنا وشركائنا.</p>',
      galleryItems: [{
          name: 'gallery-18',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-19',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-20',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-21',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-26',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-22',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-27',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-23',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-24',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-28',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-30',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-32',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-31',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        },
        {
          name: 'gallery-33',
          type: 'image',
          width: 1400,
          height: 788,
          aspect: 7 / 4
        }
      ]
    },
    ShowcaseTypo: {
      bgs: ['gallery-32', 'gallery-26', 'gallery-28', 'gallery-18'],
      title: '<h1 class="display-2 primary--text mb-6">ترتكز صناعتنا الإنتاجية على الإبداع،</h1><p class="body-1 secondary--text text--lighten-1">اعتمدنا على فريق عمل مبتكر، ومعدات حديثة، ونموذج عمل مثالي يبدأ بالفكرة والكتابة الإبداعية.</p>'
    }
  }
}

// state
const state = {
  servicesData: {
    studios,
    production
  }
}

// getters
const getters = {
  getServices: state => {
    return state.servicesData
  },
  getServiceData: state => serviceName => {
    const serviceData = state.servicesData[serviceName] ? state.servicesData[serviceName] : false
    if (!serviceData) return false
    return serviceData
  }
}

// actions
const actions = {}

// mutations
const mutations = {}

// export
export default {
  state,
  getters,
  actions,
  mutations
}